import { ElementBase as l } from "@smartdesign/element-base";
const o = `<style>
	:host {
		display: block;
	}

	.grid-variant {
		display: grid;
		grid-gap: var(--z-layout-spacing, 16px);
		grid-template-columns: repeat(auto-fill, minmax(var(--z-layout-column-width, 400px), 1fr));
		grid-template-columns: repeat(auto-fill, minmax(min(100%, var(--z-layout-column-width, 400px)), 1fr));
		justify-content: space-around;
	}

	:host([fixed-columns]) .grid-variant {
		grid-template-columns: repeat(auto-fit, var(--z-layout-column-width, 400px));
		grid-template-columns: repeat(auto-fit, min(100%, var(--z-layout-column-width, 400px)));
		justify-content: flex-start;
	}

	.flex-variant {
		display: flex;
		width: calc(100% + var(--z-layout-spacing, 16px));
		margin: calc(-0.5 * var(--z-layout-spacing, 16px));
		box-sizing: border-box;
		flex-wrap: wrap;
		justify-content: space-around;
		align-content: space-around;
	}

	:host([fixed-columns]) .flex-variant {
		justify-content: flex-start;
		align-content: center;
	}

	:host([fixed-columns]) .flex-variant ::slotted(*) {
		flex: 0 0 auto;
	}

	.flex-variant ::slotted(*) {
		flex: 1 1 auto;
		box-sizing: border-box;
		width: calc(var(--z-layout-column-width, 400px) + var(--z-layout-spacing, 16px)) !important;
	}

	.grid-variant ::slotted(*) {
		box-sizing: border-box;
		max-width: 100% !important;
	}

	.flex-variant ::slotted(:not(.filler)) {
		border: calc(var(--z-layout-spacing, 16px) / 2) solid transparent !important;
		background-clip: padding-box !important;
	}

	.flex-variant ::slotted(.filler) {
		order: 2147483647;
	}
</style>
<div class="root">
	<slot></slot>
</div>
`, s = class s extends l {
  constructor() {
    super(), this.fillers = [], this.lastKnownWidth = -1, this.debounced = {};
  }
  is() {
    return s.ID;
  }
  template() {
    const t = document.createElement("template");
    return t.innerHTML = o, t;
  }
  get fixedColumns() {
    return this.hasAttribute("fixed-columns") && this.getAttribute("fixed-columns") !== "false";
  }
  set fixedColumns(t) {
    t ? this.setAttribute("fixed-columns", "") : this.removeAttribute("fixed-columns");
  }
  get columnWidth() {
    return this.hasAttribute("column-width") ? this.getAttribute("column-width") : getComputedStyle(this).getPropertyValue("--z-layout-column-width");
  }
  set columnWidth(t) {
    this.setAttribute("column-width", t);
  }
  static get observedAttributes() {
    return ["column-width"];
  }
  connectedCallback() {
    super.connectedCallback(), this.rootElement || (this.rootElement = this.shadowRoot.querySelector(".root"), this.isGridLayoutSupported() ? this.rootElement.className = "root grid-variant" : (this.rootElement.className = "root flex-variant", this.childListObserver = new MutationObserver((t) => {
      t.reduce((i, r) => [...i, ...r.addedNodes, ...r.removedNodes], []).filter((i) => (i.className || "").indexOf("filler") === -1).length > 0 && this.debounce("update-fillers", () => {
        this.updateFillers();
      });
    }), this.resizeObserver = new ResizeObserver((t, e) => {
      this.lastKnownWidth !== this.offsetWidth && (this.lastKnownWidth = this.offsetWidth, this.debounce("update-fillers", () => {
        this.updateFillers();
      }));
    })), this.checkMarginUsageOnDirectChildren()), this.childListObserver && this.childListObserver.observe(this, { childList: !0 }), this.resizeObserver && this.resizeObserver.observe(this);
  }
  attributeChangedCallback() {
    this.onColumnWidthChange();
  }
  isGridLayoutSupported() {
    const t = navigator.userAgent.indexOf("Edge/") > -1, e = window, i = e.CSS && e.CSS.supports;
    return !t && i && CSS.supports("display", "grid");
  }
  updateFillers() {
    if (this.childElementCount > 0)
      if (this.fixedColumns)
        this.fillers.length > 0 && (this.fillers.forEach((t) => this.removeChild(t)), this.fillers = []);
      else {
        let t = Number.POSITIVE_INFINITY, e;
        for (; this.currentColumnWidth() < t; )
          t = this.currentColumnWidth(), e = this.appendFiller(), this.flushShadyDomChanges();
        this.fillers.length = this.fillers.length - 1, this.removeChild(e);
        const i = this.offsetWidth / t;
        if (isFinite(i))
          for (; i - 1 > this.fillers.length; )
            this.appendFiller();
      }
  }
  appendFiller() {
    const t = document.createElement("div");
    return t.className = "filler", this.fillers.push(t), this.appendChild(t), t;
  }
  flushShadyDomChanges() {
    const t = window.ShadyDOM;
    t && t.flush && t.flush();
  }
  checkMarginUsageOnDirectChildren() {
    requestAnimationFrame(() => {
      for (let t = 0; t < this.children.length; t++) {
        const e = this.children[t];
        if (e.className.indexOf("filler") === -1) {
          const i = getComputedStyle(e);
          if (parseInt(i.marginLeft, 10) !== 0 || parseInt(i.marginRight, 10) !== 0) {
            console.warn(
              `[sd-z-layout] It is not recommended to use horizontal margins on direct children of the sd-z-layout element because the flex-variant (which is used in browsers without css grid support) might have layouting problems.
Please consider to apply such margins inside these elements instead.`
            );
            return;
          }
        }
      }
    });
  }
  currentColumnWidth() {
    for (const t of this.children)
      if (t.offsetWidth)
        return t.offsetWidth;
  }
  onColumnWidthChange() {
    const t = window.ShadyCSS;
    this.hasAttribute("column-width") ? (this.style.setProperty("--z-layout-column-width", this.getAttribute("column-width")), t && t.styleSubtree(this, { "--z-layout-column-width": this.getAttribute("column-width") })) : (this.style.removeProperty("--z-layout-column-width"), t && t.styleSubtree(this, { "--z-layout-column-width": "" }));
  }
  disconnectedCallback() {
    this.childListObserver && this.childListObserver.disconnect(), this.resizeObserver && this.resizeObserver.disconnect();
  }
  debounce(t, e) {
    this.debounced[t] || (this.debounced[t] = !0, requestAnimationFrame(() => {
      delete this.debounced[t], e();
    }));
  }
};
s.ID = "sd-z-layout";
let n = s;
customElements.get(n.ID) || customElements.define(n.ID, n);
export {
  n as ZLayout
};
//# sourceMappingURL=zlayout.mjs.map
